export enum ModalWidth {
  small,
  normal,
  medium,
  full,
}
